import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { AppPaths } from '@ftr/routing-paths'
import { ForbiddenComponent, makePublicFeatureFlagGuard, NotFoundComponent } from '@ftr/ui-core'
import { CourtSystemForbiddenComponent } from '@ftr/ui-court-system'
import { DesktopLoginSplashComponent } from '@ftr/ui-desktop'
import { SupportedBrowsersModule } from '@ftr/ui-help'
import { LoggedInGuard } from '@ftr/ui-user'
import { ExternalLoginModule } from '~app/features/external-login/external-login.module'
import { CourtSystemForbiddenPage } from '~app/pages/court-system-forbidden.page'
import { DesktopLoginSplashPage } from '~app/pages/desktop-login-splash.page'
import { ExternalLoginPage } from '~app/pages/external-login.page'
import { LoginModule } from '../features/login/login.module'
import { ForbiddenPage } from './forbidden.page'
import { LoginPage } from './login.page'
import { LogoutPage } from './logout.page'
import { NotFoundPage } from './not-found.page'
import { SupportedBrowsersPage } from './supported-browsers.page'

@NgModule({
  imports: [
    LoginModule,
    SupportedBrowsersModule,
    ForbiddenComponent,
    NotFoundComponent,
    ExternalLoginModule,
    CourtSystemForbiddenComponent,
    DesktopLoginSplashComponent,
    RouterModule.forChild([
      {
        path: AppPaths.Login,
        component: LoginPage,
        canActivate: [LoggedInGuard],
        data: {
          title: 'Log In',
        },
      },
      {
        path: AppPaths.DesktopLoginSplash,
        component: DesktopLoginSplashPage,
        data: {
          title: 'Launching For The Record',
        },
      },
      {
        path: AppPaths.Logout,
        component: LogoutPage,
      },
      {
        path: AppPaths.SupportedBrowsers,
        component: SupportedBrowsersPage,
        data: {
          title: 'Supported Browsers',
        },
      },
      {
        path: AppPaths.Forbidden,
        component: ForbiddenPage,
      },
      {
        path: AppPaths.NotFound,
        component: NotFoundPage,
      },
      {
        path: AppPaths.ExternalLogin,
        component: ExternalLoginPage,
      },
      {
        path: AppPaths.CourtSystemForbidden,
        component: CourtSystemForbiddenPage,
      },
      {
        path: AppPaths.CourtroomDisplay,
        loadChildren: () =>
          import('./courtroom-display/courtroom-display.module').then(m => m.CourtroomDisplayPageModule),
      },
      {
        path: AppPaths.CourtroomJoin,
        loadChildren: () =>
          import('./courtroom-join/public-courtroom-join.module').then(m => m.PublicCourtroomJoinPageModule),
      },
      {
        path: AppPaths.CourtroomJoinDetail,
        loadChildren: () =>
          import('./courtroom-join-detail/public-courtroom-join-detail.module').then(
            m => m.PublicCourtroomJoinDetailPageModule,
          ),
      },
      {
        path: AppPaths.StandaloneAppDownload,
        loadChildren: () => import('./standalone-apps/standalone-apps.module').then(m => m.StandaloneAppsPageModule),
      },
      {
        path: AppPaths.Request,
        canActivateChild: [makePublicFeatureFlagGuard('public-navigation')],
        loadChildren: () => import('./request/request-pages.module').then(m => m.RequestPagesModule),
      },
    ]),
  ],
  declarations: [
    LoginPage,
    DesktopLoginSplashPage,
    LogoutPage,
    SupportedBrowsersPage,
    ForbiddenPage,
    NotFoundPage,
    ExternalLoginPage,
  ],
  exports: [RouterModule],
})
export class RootModule {}
